import { jsx } from 'react/jsx-runtime';
import '../node_modules/@optimizely/js-sdk-logging/lib/index.js';
import { setLogLevel, createInstance } from '@optimizely/optimizely-sdk';
import { createContext, useState, useEffect } from 'react';
import { Loader } from '../components/loader/loader.js';
import { sendErrorToSentry } from '../services/sentry-service.js';
import { PROD_ENVIRONMENT, BETA_ENVIRONMENT } from '../utils/common-types.js';
import { CURRENT_ENVIRONMENT } from '../utils/environment-utils.js';
import { CURRENT_SITE_ID } from '../utils/site-utils.js';
import { __exports as lib } from '../_virtual/index.js';

const optimizelySettings = {
    sdkKey: {
        development: 'UrcUsEMHCCTzQRvZrBk86',
        production: '9C7GpZMzrkGxCcZTRSZC4',
    },
};
const getOptimizelySdkKey = () => {
    switch (CURRENT_ENVIRONMENT) {
        case PROD_ENVIRONMENT:
        case BETA_ENVIRONMENT:
            return optimizelySettings.sdkKey.production;
        default:
            return optimizelySettings.sdkKey.development;
    }
};
setLogLevel(CURRENT_ENVIRONMENT === PROD_ENVIRONMENT ? lib.LogLevel.NOTSET : lib.LogLevel.INFO);
const optimizelyFeatureFlags = {
    editEmail: 'accmag-683_control_edit_email_endpoint',
    isTaxIdFlagEnabled: 'accmag-783_show_tax_id_in_new_address_form',
    isAddressSuggestionModernizedUIEnabled: 'accmag-564_show_address_suggestion_modernized_ui',
    isSameFirstAndLastNameCheckEnabled: 'sc-5174_show_warning_message_for_same_address_names',
};
const FlagsContext = createContext({});
const userId = window.optimizelyUserId || 'customer-data-frontend';
const isMobileApp = window.optimizelyUserAttributes?.isMobileApp || false;
const FlagsProvider = ({ children }) => {
    const [flags, setFlags] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const optimizelyInstance = createInstance({
            sdkKey: getOptimizelySdkKey(),
        });
        optimizelyInstance
            ?.onReady()
            .then(() => {
            const attributes = {
                siteId: CURRENT_SITE_ID,
                serverName: window.location.hostname,
                isMobileApp: isMobileApp,
                sid: userId, // sid means session ID -- derived from a cookie in checkout
            };
            const userContext = optimizelyInstance?.createUserContext(userId, attributes);
            const optimizelyFlags = {};
            const flagEntries = Object.entries(optimizelyFeatureFlags);
            for (const [key, featureFlagKey] of flagEntries) {
                optimizelyFlags[key] = Boolean(userContext?.decide(featureFlagKey).enabled);
            }
            setFlags(optimizelyFlags);
        })
            .catch((error) => {
            sendErrorToSentry(error);
        })
            .finally(() => {
            setLoading(false);
        });
    }, []);
    return (jsx(FlagsContext.Provider, { value: { flags }, children: loading ? jsx(Loader, {}) : children }));
};

export { FlagsContext, FlagsProvider, isMobileApp, optimizelyFeatureFlags, userId };
//# sourceMappingURL=flags-context.js.map
